/**
 * Created by Qingger Corp.
 * User: 李龙
 * Date: 2020/03/13
 * Time: 09:32
 * Desc: 拼团活动
 */

import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import type { ElTree } from 'element-ui/types/tree';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import { appEnvConfig } from '@/configs/appConfigs';
import GenerateLink from '@/views/components/generateLink';
import { noop, parseSec } from '@/util';
import { downloadFile } from '@/library/sheet/buffer';
import ExportFile from '@/views/components/exportFile';
import NewSelectSite from '@/views/components/newSelectSIte';

interface NodeItem {
  label: string;
  children?: Array<NodeItem>;
}
interface ActResultSiteList {
  siteId?: number;
  siteCode?: string;
  siteName?: string;
  orderNum?: number;
  orderPrice?: number;
  stock?: number;
}
interface SiteOrderList {
  orderId?: number;
  orderSn?: string;
  siteName?: string;
  siteCode?: string;
  buyerName?: string;
  buyerPhone?: string;
  specValue?: string;
  orderMoney?: number;
  productNum?: number;
  orderAddTime?: number;
  orderPayTime?: number;
  ptState?: number;
  groupHead?: string;
  headPhone?: string;
}

export enum ACT_STATE {
  NO_BEGIN = 1,
  PROGRESS,
  END,
  FUCK = 5,
  ALL = 9,
}

export enum ACT_ORDER_STATE {
  WAIT_GROUP = 1,
  GROUP,
  VI_GROUP,
  BUY,
  FAIL = 7,
  ALL = 9,
}

@Component({
  components: {
    ExportFile,
  },
})
export default class AssembleActivity extends Vue {
  public actStateText = {
    [ACT_STATE.NO_BEGIN]: '未开始',
    [ACT_STATE.PROGRESS]: '进行中',
    [ACT_STATE.END]: '已结束',
    [ACT_STATE.FUCK]: '已下架',
    [ACT_STATE.ALL]: '全部',
  };

  public actOrderStateText = {
    [ACT_ORDER_STATE.WAIT_GROUP]: '待成团',
    [ACT_ORDER_STATE.GROUP]: '已成团',
    [ACT_ORDER_STATE.VI_GROUP]: '虚拟成团',
    [ACT_ORDER_STATE.BUY]: '单买',
    [ACT_ORDER_STATE.FAIL]: '拼团失败',
    [ACT_ORDER_STATE.ALL]: '全部',
  };

  $refs: {
    elTree: ElTree<any, any>;
  };

  public defaultExpandedKeys = [];
  /**
   * 列表状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 搜索关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 活动结果搜索关键字
   * @type {string}
   */
  public actResultKeywords = '';

  public actResultSiteKeywords = '';

  /**
   * 活动结果网点列表
   * @type {}
   */
  public actResultSiteList: Array<ActResultSiteList> = [];

  /**
   * 网点订单列表
   * @type {}
   */
  public siteOrderList: Array<SiteOrderList> = [];

  /**
   * 活动状态
   * @type {string}
   */
  public ptState = '9';

  /**
   * 状态
   * @type {string}
   */
  public actState = '9';

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 网点页码
   * @type {number}
   */
  public sitePage = 1;

  /**
   * 订单页码
   * @type {number}
   */
  public orderPage = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 网点条数
   * @type {number}
   */
  public sitePageSize = 10;

  /**
   * 订单条数
   * @type {number}
   */
  public orderPageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 网点总条数
   * @type {number}
   */
  public siteTotalCount = 0;

  /**
   * 订单总条数
   * @type {number}
   */
  public orderTotalCount = 0;

  /**
   * 拼团列表
   * @type {Array<AssembleInfo>}
   */
  public assembleActivityList: Array<AssembleInfo> = [];

  /**
   * 活动结果跟踪-大区
   * @type {boolean}
   */
  public actResultShow = false;

  /**
   * 导出按钮是否可用
   * @type {boolean}
   */
  public isSocketReady = false;

  /**
   * 网点导出按钮是否可用
   * @type {boolean}
   */
  public isSiteSocketReady = false;

  /**
   * 订单导出按钮是否可用
   * @type {boolean}
   */
  public isOrderScoketReady = false;

  /**
   *  导出按钮的信息
   * @type {ItemObject}
   */
  public exportBtnInfo: Array<ItemObject> = [
    { state: 0, url: '' },
    { state: 0, url: '' }, // 网点导出按钮
    { state: 0, url: '' }, // 订单导出
  ];

  // 弹窗树的遍历
  public findNodeList = [];
  public findNodeListSiteCode = [];

  /**
   * 导出按钮标记
   * @type {number}
   */
  public index = 0;

  /**
   * 弹窗网点列表显示标记
   * @type {boolean}
   */
  public isSiteShow = false;

  /**
   * 弹窗订单列表显示标记
   * @type {boolean}
   */
  public isOrderShow = false;

  /**
   * sendToId信息
   * @type {Array<string>}
   */
  public sendToIdList: Array<string> = [];

  public sendToService: any[] = [IPSService.PtProductListExport, IPSService.adminPTActSiteExport, IPSService.adminPTActSiteExport];

  /**
   * 节点列表
   * @type {Array<NodeItem>}
   */
  public nodeList: Array<NodeItem> = [];

  /**
   * 节点key
   * @type {Object}
   */
  public defaultProps: Object = {
    children: 'children',
    label: 'name',
  };

  // 活动结果跟踪loading状态
  public actResultLoading = false;

  // 是不是网点树最后的节点
  public isLastTree = false;

  public selectPtId = '';

  public actSiteLoading = false;

  public orderSiteLoading = false;

  // 列表的选中
  public actListSelect: any[] = [];
  public actSiteListSelect: any[] = [];
  public actOrderListSelect: any[] = [];

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;

  public handleActListSelect(selection) {
    this.actListSelect = selection.map(i => i.ptId);
  }

  public handleActSiteListSelect(selection) {
    this.actSiteListSelect = selection.map(i => i.siteId);
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.loadingState = true;
    this.getAssembleList();
  }

  /**
   * 网点条数变更
   * @param {number} val
   * @retun null
   */
  public onSiteSizeChange(val: number) {
    this.sitePageSize = val;
    this.getAssembleActResult();
  }

  /**
   * 订单条数变更
   * @param {number} val
   * @return null
   */
  public onOrderSizeChange(val: number): void {
    this.orderPageSize = val;
    this.getAssembleActSiteOrderList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;

    this.getAssembleList();
  }

  /**
   * 网点列表页码变更
   * @param {number} val
   * @retun null
   */
  public onSitePageChange(val: number): void {
    this.pageSize = val;
    this.getAssembleActResult();
  }

  /**
   * 订单页码变更
   * @param {number} val
   * @return null
   */
  public onOrderPageChange(val: number): void {
    this.orderPage = val;
    this.getAssembleActSiteOrderList();
  }

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchAssembleList(): void {
    this.getAssembleList();
  }

  /**
   * 状态改变
   * @param {string} val
   * @return null
   */
  public onPtStateChange(val: string): void {
    this.page = 1;
    this.pageSize = 10;
    this.loadingState = true;

    this.getAssembleList();
  }

  /**
   * 状态改变
   * @param {string} val
   * @return null
   */
  public onActStateChange(val: string): void {
    this.page = 1;
    this.pageSize = 10;

    this.loadingState = true;

    this.getAssembleList();
  }

  /**
   * 禁用活动
   * @return null
   * @param item
   */
  public onProhibitAssemble(item): void {
    const params = {
      ptId: item.ptId,
      ptState: +item.ptState ? 0 : 1,
    };
    this.$confirm(`确认${params.ptState ? '上架' : '下架'}？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      IPSService.updateAssembleActState({ postParams: params })
        .then((res) => {
          if (res.result) {
            this.$message.success(`活动${params.ptState ? '上架' : '下架'}成功`);
            this.getAssembleList();
          } else {
            this.$message.error(`活动${params.ptState ? '上架' : '下架'}失败`);
          }
        })
        .catch(() => {
          this.$message.error(`活动${params.ptState ? '上架' : '下架'}失败`);
        });
    });
  }

  /**
   * 删除活动
   * @return null
   * @param item
   */
  public onDelAssemble(item): void {
    if (item.activityState !== 1) {
      return;
    }

    this.$confirm('确定删除？', '提示').then((res) => {
      if (res === 'confirm') {
        const params = {
          ptId: item.ptId,
        };
        IPSService.deleteAssembleAct({ postParams: params }).then((res) => {
          this.loadingState = true;
          this.getAssembleList();
        });
      }
    });
  }

  handleCloseActiveTrack() {
    this.actResultKeywords = '';
    this.actResultShow = false;
  }

  /**
   * 活动结果跟踪
   * @retuen null
   * @param item
   */
  siteCodes=[]
  public onShowOrderCount(item): void {
    // 打开弹窗时，需关闭列表页的sockets,再重新打开
    this.actResultLoading = true;
    // const treeParams = {
    //   siteCodes: (item.siteList || []).map(i => i.siteCode),
    // };

    // IPSService.getAdminAuthTree({ postParams: treeParams }).then((res) => {
    //   this.nodeList = res.treeList;
    //   this.setCurrentkey(res.treeList[0].code);
    // });

    this.siteCodes=item.siteList.map(i => i.siteCode)
    this.selectPtId = item.ptId;
    this.onSearchActResultSiteList()
    // this.handleNodeClick(this.nodeList);
    this.$set(this, 'exportBtnInfo', [
      { state: 0, url: '' },
      { state: 0, url: '' },
      { state: 0, url: '' },
    ]);

    this.actResultShow = true;
  }
  openSelectSiteDialog() {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: this.siteCodes,
      readonly: false,
    }).then((val: string[]) => {
      this.findNodeListSiteCode=val
      this.onSearchActResultSiteList()
    }, noop);
  }
  /**
   * 网点列表显示
   * @return null
   */
  public onSiteListShow(item: ItemObject): void {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: item.siteList.map(i => i.siteCode),
      readonly: true,
    }).then(noop, noop);
  }

  public dateChange() {
    this.page = 1;
    this.getAssembleList();
  }

  /**
   * 设置节点选中状态
   * @param {string} val
   * @returns null
   */
  public setCurrentkey(val: string): void {
    this.$nextTick(() => {
      (this.$refs.elTree as ElTree<any, any>).setCurrentKey(val);
    });
  }

  /**
   * 点击节点
   * @param {string} data
   * @return null
   */
  public handleNodeClick(data): void {
    this.findNodeListSiteCode = [];
    this.AssembleActSiteOrderCode = '';
    if (data && data.code) {
      this.setCurrentkey(data.code);
    }
    this.$set(this, 'actResultSiteList', []);
    if (data.isSite) {
      this.orderSiteLoading = true;
      this.isLastTree = true;

      this.AssembleActSiteOrderCode = data.code;

      this.getAssembleActSiteOrderList();
    } else {
      this.actSiteLoading = true;
      this.isLastTree = false;
      this.findNodeList = [];
      this.findNodeSite(data);

      this.findNodeListSiteCode = this.findNodeList.map((i) => {
        return i.code;
      });

      this.getAssembleActResult();
    }
  }

  public getAssembleActResult() {
    this.actSiteLoading = true;
    const params = {
      ptId: this.selectPtId,
      keyword: this.isLastTree ? this.actResultSiteKeywords : this.actResultKeywords,
      siteCodes: this.findNodeListSiteCode.length < 1 ? '1' : this.findNodeListSiteCode,
      page: this.sitePage,
      pageSize: this.sitePageSize,
    };
    IPSService.assembleActResult({ postParams: params })
      .then((res) => {
        this.$set(this, 'actResultSiteList', res.list);
        this.siteTotalCount = res.count;
        this.actResultLoading = false;
        this.actSiteLoading = false;
      })
      .catch((err) => {
        this.actResultLoading = false;
        this.actSiteLoading = false;
        this.$message.error('活动结果获取失败！');
      });
  }

  public findNodeSite(node) {
    if (Object.prototype.toString.call(node) === '[object Object]') {
      node = [node];
    }
    node.forEach((i) => {
      if (i.isSite) {
        this.findNodeList.push(i);
      }
      if (i.children && !i.isSite) {
        this.findNodeSite(i.children);
      }
    });
  }

  exportParams(index: number) {
    this.index = index;
    let postParams: any = {};
    switch (index) {
      case 0:
        postParams = {
          exportType: 'ptProduct',
          params: {
            keywords: this.keywords,
            activityState: +this.actState,
            ptState: +this.ptState,
            ptIds: this.actListSelect,
          },
        };
        if (this.date && this.date.length) {
          (postParams.params['startOfTime'] = parseSec(1, this.date[0])), (postParams.params['endOfTime'] = parseSec(2, this.date[1]));
        }
        break;
      case 1:
        postParams = {
          exportType: 'ptAct',
          params: {
            siteCodes: this.findNodeListSiteCode.length ? this.findNodeListSiteCode : '1',
            ptId: this.selectPtId,
            keyword: this.actResultKeywords,
            codes: this.actSiteListSelect,
            exportType: index,
          },
        };
        break;
      case 2:
        postParams = {
          exportType: 'ptAct',
          params: {
            siteCode: this.AssembleActSiteOrderCode,
            ptId: this.selectPtId,
            ptState: +this.AssembleActSiteOrderState,
            keyword: this.actResultSiteKeywords,
            orderIds: this.actOrderListSelect,
            exportType: index,
          },
        };
    }
    return postParams;
  }

  // 弹窗的关闭
  activityResultDialogClose() {
    this.defaultExpandedKeys = [];
    // 清空表格的数据
    this.actResultKeywords = '';
    this.actResultSiteKeywords = '';
    this.isLastTree=false
    this.findNodeListSiteCode = [];
    this.findNodeList = [];
    this.nodeList = [];
    this.selectPtId = '';
    this.siteOrderList = [];
    this.actResultSiteList = [];
    this.actSiteListSelect = [];
    this.AssembleActSiteOrderCode = '';
    this.actOrderListSelect = [];
  }

  /**
   * 活动结果订单列表搜索
   */
  public onSearchActResultSiteList() {
    if (this.isLastTree) {
      this.getAssembleActSiteOrderList();
    } else {
      this.getAssembleActResult();
    }
  }

  public AssembleActSiteOrderCode = '';
  public AssembleActSiteOrderState = '9';

  public assembleActSiteOrderChange() {
    this.getAssembleActSiteOrderList();
  }

  /**
   * 活动网点订单详情
   * @return null
   */
  public onActSiteOrderDetail(item): void {
    this.isLastTree = true;
    if (item.siteCode) {
      this.defaultExpandedKeys = [item.siteCode];
    }
    this.AssembleActSiteOrderCode = item.siteCode;
    this.getAssembleActSiteOrderList();
  }

  public getAssembleActSiteOrderList() {
    this.orderSiteLoading = true;
    const postParam = {
      ptId: this.selectPtId,
      keyword: this.isLastTree ? this.actResultSiteKeywords : this.actResultKeywords,
      siteCode: this.AssembleActSiteOrderCode,
      ptState: +this.AssembleActSiteOrderState,
      page: this.orderPage,
      pageSize: this.orderPageSize,
    };
    IPSService.assembleActSiteOrderList({ postParams: postParam })
      .then((res) => {
        this.siteOrderList = (res.list || []).map((i) => {
          i.orderAddTime = moment(i.orderAddTime * 1000).format('YYYY-MM-DD HH:mm:ss');
          i.orderPayTime = +i.orderPayTime ? moment(i.orderPayTime * 1000).format('YYYY-MM-DD HH:mm:ss') : '/';
          return i;
        })||[];
        console.log(this.siteOrderList)
        this.orderTotalCount = res.count;
        this.orderSiteLoading = false;
      })
      .catch((err) => {
        this.orderSiteLoading = false;
      });
  }

  public empCode = '';
  /**
   * 组件创建时
   * @return null
   */
  public created(): void {
    this.loadingState = true;
    this.sendToIdList[0] = `${appEnvConfig.NODE_ENV}AssembleActivity${this.$store.state.empCode}`;
    this.sendToIdList[1] = `${appEnvConfig.NODE_ENV}AssembleActivitySite${this.$store.state.empCode}`;
    this.sendToIdList[2] = `${appEnvConfig.NODE_ENV}AssembleActivityOrder${this.$store.state.empCode}`;
    this.defaultStart = parseSec(3);
    this.defaultEnd = parseSec(4);
    this.date = [this.defaultStart, this.defaultEnd];
    this.getAssembleList();
    this.empCode = localStorage.getItem('empCode') || '';
  }

  // 拼团活动链接
  public onLink(item) {
    GenerateLink.open({
      item,
      title: '生成拼团链接',
      type: 'assembleActivity',
      confirm: false,
    }).then(noop, noop);
  }

  /**
   * 获取拼团活动列表
   * @return  null
   */
  public getAssembleList(): void {
    const postParams = {
      keyword: this.keywords,
      ptState: +this.ptState,
      activityState: +this.actState,
      page: this.page,
      pageSize: this.pageSize,
    };
    if (this.date && this.date.length) {
      (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('创建时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
        return;
      }
    }
    this.ipsGetList(postParams);
  }

  ipsGetList(postParams) {
    IPSService.assembleActList({ postParams })
      .then((response) => {
        this.totalCount = response.count;
        const result = response.list;
        // 格式化数据
        result.forEach((element) => {
          element.actBeginTime = Functions.timeFormatSec(element.actBeginTime);
          element.actEndTime = Functions.timeFormatSec(element.actEndTime);
          // element.addTime = Functions.timeFormatSec(element.addTime);
        });
        this.assembleActivityList = result;

        this.loadingState = false;
      })
      .catch((err) => {
        this.loadingState = false;
        console.log(err);
      });
  }

  /**
   * 新建/编辑活动
   * @return null
   * @param item
   */
  public editAssembleAct(item?): void {
    const params = { state: 0, id: 0 };
    if (item) {
      params.state = item.activityState;
      params.id = item.ptId;
    }
    this.$router.push({
      path: `/assembleActEdit/${params.id}/${params.state}`,
    });
  }
}
